import {Dispatch, FC} from 'react';
import EditableField from '../common/fields/EditableField';
import permissionsInfo from '../../constants/permissionsInfo';
import EnsurePermission from '../common/EnsurePermission';
import {operatoryValidationSchema} from '../../constants/validationSchemes';
import {OperatoryListProps} from '../../constants/types';
import {OperatoryToDeleteProps} from './index';
import {useTranslation} from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

type OperatoryRowProps = {
  operatory: OperatoryListProps,
  editHandler: (id?: number, data?: any) => any,
  handleToggleAddForm: () => void,
  setOperatoryToDelete: Dispatch<OperatoryToDeleteProps>,
  isDeleteIconVisible: boolean
};

const Row: FC<OperatoryRowProps> = ({
  operatory,
  editHandler,
  handleToggleAddForm,
  setOperatoryToDelete,
  isDeleteIconVisible
}) => {
  const {t} = useTranslation('operatories');
  const {id, currentlyInUse, desc, number} = operatory;

  const cellItem = {
    rowId: id,
    editHandler,
    permission: permissionsInfo.operatories.edit,
    editModeToggleCallback: handleToggleAddForm
  };

  const button = (
    <IconButton
      disabled={currentlyInUse}
      className="icon-button gray small"
      onClick={() => {
        setOperatoryToDelete({
          id,
          message: t('popup.deleteMessage', {number})
        });
        handleToggleAddForm();
      }}
    >
      <DeleteIcon className="icon" />
    </IconButton>
  );

  return (
    <tr className="row">
      <td className="cell">
        <EditableField
          validationSchema={operatoryValidationSchema}
          cellItem={{...cellItem, cellData: {desc}}}/>
      </td>
      <td className="cell">
        <EditableField
          validationSchema={operatoryValidationSchema}
          cellItem={{...cellItem, cellData: {number}}}/>
      </td>
      {isDeleteIconVisible &&
        <EnsurePermission
          elementPermissions={permissionsInfo.operatories.delete}
        >
          <td className="cell narrow-cell">
            {!currentlyInUse ? button : (
                <Tooltip title={<span>{t('tooltip.message')}</span>}>
                  <div>
                    {button}
                  </div>
                </Tooltip>
              )}
          </td>
        </EnsurePermission>
      }
    </tr>
  );
};

export default Row;
